<template>
    <Modal
        size="lg"
        :title="$t('form.button.requestFeedback') + ' Feedback'"
        :ok-title="$t('form.button.send')"
        :ok-disabled="false"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        :hide-header-close="isSubmitting"
        is-modal-route
        :okOnly="true"
        :hide-footer="true"
    >
        <div class="modal-admin-request">
            <h2 class="choose-option">
                {{ $t('talk.modal.title') }}
            </h2>
            <div class="request-options">
                <div
                    class="request-options_item"
                    v-for="option in requestsOptions"
                    :key="option + '_request_feedback_option'"
                    @click="select(option)"
                    :class="{ active: selected === option }"
                >
                    <div class="icon">
                        <self-icon v-if="option === 'self'" />
                        <others-icon v-if="option === 'others'" />
                    </div>
                    <div class="content">
                        <h5 class="content-title">
                            {{ $t(`talk.modal.${option}.title`) }}
                        </h5>
                        <span
                            class="content-description"
                            v-html="$t(`talk.modal.${option}.description`)"
                        ></span>
                    </div>
                </div>
            </div>

            <self-form
                @close-modal="onModalCloseHandler"
                class="self"
                v-if="selfIsSelected"
            />
            <others-form
                @close-modal="onModalCloseHandler"
                class="others"
                v-if="othersIsSelected"
            />
        </div>
    </Modal>
</template>

<script>
import Modal from '@/views/components/modal'

import { SelfIcon, SelfForm, OthersIcon, OthersForm } from './children'

export default {
    name: 'RequestAdminFeedbackModal',
    components: {
        Modal,
        SelfForm,
        SelfIcon,
        OthersIcon,
        OthersForm,
    },
    data() {
        return {
            isSubmitting: false,
            requestsOptions: ['self', 'others'],
            selected: null,
        }
    },
    mounted() {
        if (!this.canViewModal) {
            this.onModalCloseHandler()
        }
    },
    methods: {
        select(option) {
            this.selected = this.selected === option ? null : option
        },
        onModalCloseHandler() {
            this.$router.go(-1)
        },
    },
    computed: {
        canViewModal() {
            return this.hasAdminRole || this.isValuesMaster
        },
        currentUser() {
            return this.$store.state.currentUser.user
        },
        selfIsSelected() {
            return this.selected === 'self'
        },
        othersIsSelected() {
            return this.selected === 'others'
        },
        hasAdminRole() {
            return (
                this.currentUser.role.name === 'administrator' ||
                this.currentUser.role.name === 'local_administrator' ||
                this.currentUser.role.name === 'god'
            )
        },
        isValuesMaster() {
            return !!this.currentUser.is_values_master
        },
    },
}
</script>
<style lang="sass" scoped>
$darkBlue: #022B4F
$gray: #808080
$black: #23282c
.modal-admin-request
    color: $black
    padding: 0 15px
    font-weight: 400

    .choose-option
        font-size: 16px
        color: $black
        font-weight: 400

    .request-options
        display: flex
        justify-content: space-between
        &_item
            display: flex
            border: 1px solid $gray
            width: 47%
            border-radius: 4px
            cursor: pointer
            transition: 0.3s ease all
            .icon
                width: 15%
                display: flex
                justify-content: center
                align-items: center
                border-right: 1px solid $gray
            .content
                width: 85%
                color: $gray
                display: flex
                flex-direction: column
                justify-content: center
                align-items: flex-start
                padding: 5px 8px
                &-title
                    font-size: 14px
                    font-weight: bold
                &-description
                    font-size: 12px
            &:hover
                background-color: $darkBlue
                .content
                    color: #fff
                .icon
                    border-color: #fff
                    ::v-deep
                        .icon
                            transition: 0.3 ease all
                            fill: #fff
    .active
        background-color: $darkBlue
        .content
            color: #fff
        .icon
            border-color: #fff
            ::v-deep
                .icon
                    fill: #fff
::v-deep
    .modal-dialog
        display: flex
        flex-direction: column
        justify-content: center
        min-height: calc(100% - 3.5rem)
    .modal-header
        border: 0
        padding-bottom: 0
    .modal-title
        font-size: 20px
    .modal-body
        font-size: 16px
        color: $black
        font-weight: 400
    .modal-footer
        border-top: 0
        padding-top: 0px
        padding-right: 30px
        button
            width: 78px
</style>
